import React, { Dispatch, SetStateAction, useState } from 'react';

export const useBase64FromFileInput = () => {
  const [base64Content, setBase64Content] = useState<string>();
  const [fileName, setFileName] = useState<string>();

  const toBase64FromFile = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.currentTarget.files && e.currentTarget.files[0]) {
      setBase64Content((_) => undefined);
      const file = e.currentTarget.files[0];
      setFileName(file.name);

      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        setBase64Content(`${reader.result}`);
      };
    }
  };

  return { toBase64FromFile, base64Content, fileName };
};

export const fileToBase64 = (file: File, setBase64Content: Dispatch<SetStateAction<string | undefined>>) => {
  setBase64Content((_) => undefined);
  const reader = new FileReader();
  reader.onload = () => {
    const base64: string = reader.result as string;
    setBase64Content(base64);
  };
  reader.readAsDataURL(file);
};
